import { UNKNOWN, UNASSIGNED } from "core/constants";

export default function buildUserName(item) {
  let result = UNKNOWN;
  if (item?.first_name) {
    result = item.first_name;
  }
  if (item?.last_name) {
    result += " " + item.last_name;
  }
  if (item?.unassigned) {
    result = UNASSIGNED;
  }

  return result;
}
